import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExposureByTask, ExposureByTaskGroup, ExposureTaskDistribution } from 'src/app/models/exposureBySeg.model';

import { SEG } from 'src/app/models/seg.model';

@Component({
  standalone: false,
  selector: 'app-exposure-by-task-group',
  templateUrl: './exposure-by-task-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-by-task-group.component.scss']
})
export class ExposureByTaskGroupComponent implements OnInit {
  @Input() selectedTaskGroup: ExposureByTaskGroup;
  @Input() exposureAllSEGs: SEG[];
  @Input() exposureTaskDistributionsNew: ExposureTaskDistribution[];
  @Input() exposureByTaskGroupName: ExposureByTask[];
  @Input() show: boolean = false;
  @Input() loadingAllSEGs: boolean = true;
  @Input() loadingExposureTaskDistribution: boolean = true;
  @Input() loadingExposureByTaskGroup: boolean = true;
  @Input() taskRequestType: 'group' | 'task' = 'group';

  @Output() hideTaskGroupEmit = new EventEmitter<any>();
  @Output() toggleTaskPopupEmit = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  hideTaskGroupFn(event: Event) {
    this.hideTaskGroupEmit.emit(event);
  }

  toggleTaskPopupFn(task: ExposureByTask) {
    this.toggleTaskPopupEmit.emit(task);
  }

}
